<template>
<div>
    <el-tabs v-model="tabsKey" type="card" @tab-click="handleClick">
        <el-tab-pane label="詳細" name="Detail">
            <Detail @back="back" :memberKey="memberKey" @editTabs="editTabs" />
        </el-tab-pane>
        <el-tab-pane label="辦卡紀錄" name="card">
            <card :memberKey="memberKey" />
        </el-tab-pane>
        <el-tab-pane label="推薦人記錄" name="referrer">
            <referrer :memberKey="memberKey" />
        </el-tab-pane>
        <el-tab-pane label="禮卷記錄" name="coupon">
            <coupon :memberKey="memberKey" />
        </el-tab-pane>
        <el-tab-pane label="消費記錄" name="order">
            <order :memberKey="memberKey" @detailTabs="detailTabs" />
        </el-tab-pane>
        <el-tab-pane label="訂單明細" name="orderdetail" v-if="isShowDetail">
            <orderDetail :orderKey="orderKey" @chreListTabs="chreListTabs" />
        </el-tab-pane>
        <el-tab-pane label="退換貨記錄" name="chrelist" v-if="isShowList">
            <chrelist :orderKey="orderKey" />
        </el-tab-pane>
    </el-tabs>

</div>
</template>

<script>
import Detail from './Detail'
import order from './order'
import card from './card'
import referrer from './referrer'
import coupon from './coupon'
import orderDetail from './orderDetail'
import chrelist from './chrelist'
export default {
    name: 'memberDetail',
    props: {
        memberKey: String
    },
    components: {
        Detail,
        order,
        card,
        orderDetail,
        referrer,
        coupon,
        chrelist
    },
    data() {
        return {
            tabsKey: 'Detail',
            memKey: '',
            isShowDetail: false,
            isShowList: false,
        }
    },
    methods: {
        back() {
            this.$emit('back')
        },
        editTabs(memberKey) {
            this.memKey = memberKey
            this.$emit('editTabs', this.memKey)
        },
        detailTabs(orderKey) {
            this.isShowDetail = true
            this.tabsKey = "orderdetail"
            this.orderKey = orderKey
        },
        chreListTabs(orderKey) {
            this.isShowList = true
            this.tabsKey = "chrelist"
            this.orderKey = orderKey
        },
        handleClick: function (tab) {
            if (tab.name == 'Detail' || tab.name == 'order' || tab.name == 'card' || tab.name == 'referrer') {
                this.isShowDetail = false
                this.isShowList = false
            }
        }
    },
}
</script>
